const AUTOPLAY_DELAY = 5000;
const TRANSITION_DURATION = 750;

export function initStackingSlider() {
    for (const section of document.querySelectorAll('.js-stackingSlider')) {
        const cardsContainer = section.querySelector('.stackingSlider__cards');
        if (!cardsContainer) continue;

        const cards = [...cardsContainer.querySelectorAll('.stackingSlider__card')];
        if (cards.length < 2) continue;

        const captionEl = section.querySelector('.js-stackingSlider__caption');

        const getCaption = (slot) => {
            const card = cards.find(c => c.dataset.slot === slot);
            return card?.querySelector('.stackingSlider__captionSrc')?.innerHTML ?? '';
        };

        const updateCaption = (html) => {
            if (!captionEl) return;
            captionEl.classList.remove('is-visible');
            setTimeout(() => {
                captionEl.innerHTML = html;
                captionEl.classList.add('is-visible');
            }, TRANSITION_DURATION / 2);
        };

        // Initial slots: card[0]=front(0), card[1]=middle(1), card[2]=back(2), rest hidden
        cards.forEach((card, i) => {
            card.dataset.slot = i < 3 ? String(i) : 'hidden';
        });

        if (captionEl) {
            captionEl.innerHTML = getCaption('0');
            captionEl.classList.add('is-visible');
        }

        const rotate = () => {
            // The card at slot 1 (middle) moves to slot 0 (front) — raise z-index first
            const comingToFront = cards.find(c => c.dataset.slot === '1');
            if (comingToFront) comingToFront.style.zIndex = '10';

            // Rotate: slot 2→1 (back→mid), slot 1→0 (mid→front), slot 0→2 (front→back)
            cards.forEach(card => {
                const slot = parseInt(card.dataset.slot, 10);
                if (!isNaN(slot)) card.dataset.slot = String((slot - 1 + 3) % 3);
            });

            // Reset inline z-index after CSS transition completes
            if (comingToFront) {
                setTimeout(() => { comingToFront.style.zIndex = ''; }, TRANSITION_DURATION);
            }

            updateCaption(getCaption('0'));
        };

        section.classList.add('is-initialized');

        // Reduced motion: keep the static stack (slots and caption are set
        // above, otherwise the cards would overlap unpositioned), no autoplay.
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) continue;

        let isPlaying = true;
        let intervalId = setInterval(rotate, AUTOPLAY_DELAY);

        const button = document.createElement('button');
        button.className = 'stackingSlider__playPause';
        button.setAttribute('aria-label', 'Pause animation');
        button.innerHTML = '<i class="icon icon-pause" aria-hidden="true"></i>';

        button.addEventListener('click', () => {
            isPlaying = !isPlaying;
            if (isPlaying) {
                intervalId = setInterval(rotate, AUTOPLAY_DELAY);
            } else {
                clearInterval(intervalId);
            }
            button.innerHTML = isPlaying
                ? '<i class="icon icon-pause" aria-hidden="true"></i>'
                : '<i class="icon icon-play" aria-hidden="true"></i>';
            button.setAttribute('aria-label', isPlaying ? 'Pause animation' : 'Play animation');
        });

        section.querySelector('.stackingSlider__stage').appendChild(button);
    }
}